import React from 'react'

import { Page } from '../../../../components/layouts/page'
import { Column } from '../../../../components/layouts/columns'
import { Form } from '../../../../components/ui/form'
import { FormConsents } from './form/formConsents'
import useEditConsents from './hooks/useEditConsents'

export const AdminEditConsents = () => {
  const { loading, formContext, setFormContext, handleEditConsent } = useEditConsents()

  return (
    <Page.Section className="is-fullheight-with-navbar">
      <Form.Root
        action={() => {
          handleEditConsent()
        }}
      >
        <Column.Root>
          <Column.Content>
            <p className="subtitle is-size-3">Consentimentos</p>
          </Column.Content>
        </Column.Root>
        <FormConsents loading={loading} values={formContext} setValues={setFormContext} disabledList={{}} />
      </Form.Root>
    </Page.Section>
  )
}
